export default __webpack_public_path__ + "static/media/6.38ab53d9.svg";